import React from 'react';

export const ResultsSection: React.FC = () => {
  return (
    <section className="mb-32">
      <h2 className="text-5xl font-extrabold text-gray-900 mb-12 leading-tight text-center">
        The Edge Top CX Consultancies Demand
      </h2>
      <blockquote className="text-2xl italic text-gray-700 mb-12 bg-gradient-to-br from-blue-50 to-blue-100 p-16 rounded-2xl shadow-sm border-l-4 border-blue-600">
        "I need insights that quantify what my gut has been telling me about customer psychology - frameworks that reveal the emotional drivers beyond what traditional metrics capture."
      </blockquote>
      
      <div className="grid md:grid-cols-2 gap-8">
        <div className="bg-gradient-to-br from-gray-50 to-gray-100 p-12 rounded-2xl shadow-sm">
          <h3 className="text-3xl font-extrabold text-gray-900 mb-6">Uncovering Hidden Barriers</h3>
          <p className="text-xl text-gray-600 leading-relaxed">Identify psychological friction points that prevent conversion despite optimized interfaces</p>
        </div>

        <div className="bg-gradient-to-br from-gray-50 to-gray-100 p-12 rounded-2xl shadow-sm">
          <h3 className="text-3xl font-extrabold text-gray-900 mb-6">Avoiding Experience Gaps</h3>
          <p className="text-xl text-gray-600 leading-relaxed">Stop investing in touchpoint improvements that don't address the underlying emotional needs</p>
        </div>

        <div className="bg-gradient-to-br from-gray-50 to-gray-100 p-12 rounded-2xl shadow-sm">
          <h3 className="text-3xl font-extrabold text-gray-900 mb-6">Winning Competitive Pitches</h3>
          <p className="text-xl text-gray-600 leading-relaxed">Demonstrate customer understanding that your competitors miss in their journey maps</p>
        </div>

        <div className="bg-gradient-to-br from-gray-50 to-gray-100 p-12 rounded-2xl shadow-sm">
          <h3 className="text-3xl font-extrabold text-gray-900 mb-6">Accelerating Client Success</h3>
          <p className="text-xl text-gray-600 leading-relaxed">Target the specific psychological drivers that unlock loyalty others struggle to build</p>
        </div>
      </div>
    </section>
  );
};